import { useIntl } from 'react-intl';

import type { CommandeRow } from '../../types/commande.types';
import { $CardList, $EmptyState } from '../DossierCardList/DossierCardList.styles';
import CommandeCard from './CommandeCard';
import messages from './messages';

export interface CommandeCardListProps {
  commandes: CommandeRow[];
  searchQuery?: string;
  dataTestId?: string;
}

const CommandeCardList = ({
  commandes,
  searchQuery = '',
  dataTestId = 'commandes-card-list',
}: CommandeCardListProps) => {
  const intl = useIntl();

  if (commandes.length === 0) {
    return (
      <$EmptyState data-testid={`${dataTestId}-empty`}>
        {searchQuery.trim() !== ''
          ? intl.formatMessage(messages.emptySearch)
          : intl.formatMessage(messages.emptyList)}
      </$EmptyState>
    );
  }

  return (
    <$CardList data-testid={dataTestId}>
      {commandes.map((commande) => (
        <CommandeCard key={commande.numeroCommande} commande={commande} />
      ))}
    </$CardList>
  );
};

export default CommandeCardList;
